export const useColors = () => ({
  bgPrimary: 'var(--bg-primary)',
  bgSecondary: 'var(--bg-secondary)',
  bgCard: 'var(--bg-card)',
  bgSidebar: 'var(--bg-sidebar)',
  textPrimary: 'var(--text-primary)',
  textSecondary: 'var(--text-secondary)',
  textMuted: 'var(--text-muted)',
  border: 'var(--border)',
  accent: 'var(--accent)',
  accentText: 'var(--accent-text)',
  surface: 'var(--surface)',
})
